import React from 'react';
import { useSelector } from 'react-redux';
import { Route } from 'react-router-dom';

import { FlaggedRouteType } from 'src/routes';
import { featureFlagsByFlagSelector } from 'src/store/featureFlags/selectors';

type Props = {
  routeInfo: FlaggedRouteType;
};

/**
 * temporary route for new pages
 * it allows to turn on/off React bundle on particular page/place depending on flags
 */
export const FeatureFlagCheckRoute: React.FC<Props> = ({ routeInfo: { flag, path, component } }: Props) => {
  const allowed = useSelector(featureFlagsByFlagSelector(flag));

  return allowed ? <Route path={path} component={component} key={path.toString()} /> : null;
};
